<mat-grid-list cdkDropListGroup [cols]="groups.length">
    @for (list of groups; track list; let i = $index) {
    <mat-grid-tile class="drag-drop-group">
        <div class="dragList">
            {{groupTitles?.[i]}}
            <mat-list cdkDropList [cdkDropListData]="list" (cdkDropListDropped)="onCdkDropListDropped($event)"
                class="drag-drop-list">
                @for (item of list; track item) {
                <div cdkDrag class="drag-drop-item">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <forge-icon name="drag_indicator"></forge-icon>
                        <div fxLayout="column">
                            <div class="forge-typography--heading2">
                                {{getDisplay(item)}}
                            </div>
                            <div class="forge-typography--subheading1">
                                {{getSubtitle(item)}}
                            </div>
                        </div>
                    </div>
                </div>
                }
            </mat-list>
        </div>
    </mat-grid-tile>
    }
</mat-grid-list>